module.exports = __webpack_public_path__ + "static/media/unread.f61b2bb4.svg";